exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "  .sf-1 {\n    fill: #fff;\n  }\n\n  .sf-4{\n    fill:#fff;\n  }\n  .sf-1{\n    stroke:#707070;\n  }\n  .sf-2{\n    clip-path:url(#clip-path);\n  }\n  .sf-3{\n    fill:#00a1e0;\n  }\n", ""]);
